import React from 'react';
import { connect } from 'react-redux';
import { PresentationComponentBase } from 'acscp/components/presentationComponentBase';
import { Dispatch } from 'redux';
import { AppState, BrokerDetails as Broker, Menu } from 'acscp/store';
import { AllBrokerDetailsRequest } from 'acscp/api/requests';
import { FetchRequest, SetOpenMenu } from 'acscp/actions';
import { SideScreen } from 'acscp/components/common/sideScreen';
import screenStyle from 'acscp/components/common/sideScreen.module.scss';
import style from './brokerDetails.module.scss';
import classNames from 'classnames';
import { FormattedMessage } from 'react-intl';
import { CroppedImage } from 'acscp/components/common/croppedImage';
import { connectWithRequests } from 'acscp/store/helpers/connectWithRequests';
import { CrossIcon } from 'acscp/components/common/icons/crossIcon';
import { MailTo } from 'acscp/components/common/mailToLink';
import { userIsLoggedIn } from 'acscp/store/helpers/authHelper';

interface BrokerDetailsStateProps {
    broker?: Broker;
    isOpen: boolean;
    isLoggedIn: boolean;
}

interface BrokerDetailsDispatchProps {
    fetchBrokerDetails: () => void;
    closeMenu: () => void;
}

export class BrokerDetailsPresentational extends PresentationComponentBase<{},
    BrokerDetailsStateProps, BrokerDetailsDispatchProps, {}> {

    componentDidUpdate(propsPrev: BrokerDetailsStateProps, statePrev: {}): void {
        if (this.props.isOpen && !propsPrev.isOpen && this.props.isLoggedIn) {
            this.props.fetchBrokerDetails();
        }
    }

    render(): JSX.Element | null {
        const { broker, isOpen, closeMenu } = this.props;
        if (isOpen && broker !== undefined) {
            const url = broker.image ? broker.image.url : undefined;

            const emailItemHeading = (
                <FormattedMessage
                    id={'components.auth.brokerDetails.email'}
                    defaultMessage={'Email'}
                />
            );

            return (
                <SideScreen>
                    <div className={screenStyle.BlueHeader}>
                        <FormattedMessage
                            id={'components.auth.brokerDetails.myAccountManager'}
                            defaultMessage={'MY ACCOUNT MANAGER'}
                        />
                        <a href="javascript:;" id="ExitBrokerDetails" onClick={closeMenu} aria-label="Close">
                            <CrossIcon />
                        </a>
                    </div>
                    <div className={style.Border} >
                        <div className={style.BrokerHeader} >
                            <div className={style.BrokerImage}>
                                <CroppedImage src={url} ratio={1} />
                            </div>
                            <div className={style.LargeName}>
                                {broker.fullname}
                            </div>
                        </div>
                    </div>
                    <div className={classNames(screenStyle.MediumItem, screenStyle.WithBorder)}>
                        <FormattedMessage
                            id={'components.auth.brokerDetails.landline'}
                            defaultMessage={'Landline'}
                        />: <span className={screenStyle.Info}>{broker.landline}</span></div>
                    <div className={classNames(screenStyle.MediumItem, screenStyle.WithBorder)}>
                        <FormattedMessage
                            id={'components.auth.brokerDetails.mobile'}
                            defaultMessage={'Mobile'}
                        />: <span className={screenStyle.Info}>{broker.mobile}</span></div>
                    <div className={screenStyle.ItemWithLink}>
                        {broker.email
                            ? (
                                <MailTo email={broker.email} highlight={false} truncate={true}>
                                    {emailItemHeading}: <span className={screenStyle.Info}>{broker.email}</span>
                                </MailTo>
                            )
                            : (
                                <span>{emailItemHeading}:</span>
                            )
                        }
                    </div>
                </SideScreen>
            );
        } else {
            return (
                null
            );
        }
    }
}

function mapStateToProps(state: AppState, ownProps: {}): BrokerDetailsStateProps {
    return {
        broker: state.broker.broker,
        isOpen: state.menu.currentlyOpenMenu === Menu.BrokerDetails,
        isLoggedIn: userIsLoggedIn(state.auth)
    };
}

function mapDispatchToProps(dispatch: Dispatch, ownProps: {}): BrokerDetailsDispatchProps {
    return {
        fetchBrokerDetails: () => dispatch(new FetchRequest(new AllBrokerDetailsRequest())),
        closeMenu: () => dispatch(new SetOpenMenu(undefined))
    };
}

export const BrokerDetails = connectWithRequests(mapStateToProps, mapDispatchToProps)
    (BrokerDetailsPresentational);
